import { render, staticRenderFns } from "./TodoOptimized.vue?vue&type=template&id=92d3e3aa&scoped=true&"
import script from "./TodoOptimized.vue?vue&type=script&lang=js&"
export * from "./TodoOptimized.vue?vue&type=script&lang=js&"
import style0 from "./TodoOptimized.vue?vue&type=style&index=0&id=92d3e3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d3e3aa",
  null
  
)

export default component.exports